// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditBidPackageDetailsStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EditBidPackageDetailsStepQuery = { __typename?: 'Query', bidScopeSourceDetail: Array<{ __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource, name: string }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> };

export type EditBidPackageDetailsStep_BidScopeSourceFragment = { __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource, name: string };

export const EditBidPackageDetailsStep_BidScopeSourceFragmentDoc = gql`
    fragment EditBidPackageDetailsStep_BidScopeSource on BidScopeSourceDetail {
  code
  name
}
    `;
export const EditBidPackageDetailsStepDocument = gql`
    query EditBidPackageDetailsStep {
  bidScopeSourceDetail {
    ...EditBidPackageDetailsStep_BidScopeSource
  }
  markets {
    ...Named
  }
  costCodes(filter: {version: 2}) {
    ...Named
  }
}
    ${EditBidPackageDetailsStep_BidScopeSourceFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useEditBidPackageDetailsStepQuery__
 *
 * To run a query within a React component, call `useEditBidPackageDetailsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditBidPackageDetailsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditBidPackageDetailsStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditBidPackageDetailsStepQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EditBidPackageDetailsStepQuery, EditBidPackageDetailsStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditBidPackageDetailsStepQuery, EditBidPackageDetailsStepQueryVariables>(EditBidPackageDetailsStepDocument, options);
      }
export function useEditBidPackageDetailsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditBidPackageDetailsStepQuery, EditBidPackageDetailsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditBidPackageDetailsStepQuery, EditBidPackageDetailsStepQueryVariables>(EditBidPackageDetailsStepDocument, options);
        }
export function useEditBidPackageDetailsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditBidPackageDetailsStepQuery, EditBidPackageDetailsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditBidPackageDetailsStepQuery, EditBidPackageDetailsStepQueryVariables>(EditBidPackageDetailsStepDocument, options);
        }
export type EditBidPackageDetailsStepQueryHookResult = ReturnType<typeof useEditBidPackageDetailsStepQuery>;
export type EditBidPackageDetailsStepLazyQueryHookResult = ReturnType<typeof useEditBidPackageDetailsStepLazyQuery>;
export type EditBidPackageDetailsStepSuspenseQueryHookResult = ReturnType<typeof useEditBidPackageDetailsStepSuspenseQuery>;
export type EditBidPackageDetailsStepQueryResult = Apollo.QueryResult<EditBidPackageDetailsStepQuery, EditBidPackageDetailsStepQueryVariables>;